import { AbstractDrawableItem } from "./AbstractDrawableItem";

export abstract class AbstractRectangleItem extends AbstractDrawableItem {
  constructor(typeKey: string) {
    super(typeKey);
  }
}
